module.exports = __webpack_public_path__ + "birthday-picker-967bafdd.html";